module.exports = __webpack_public_path__ + "img/status-success.bd660990.svg";